import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * 
 * @returns {Array<Aircraft>} fleet
 */
function useFleet() {
    const fleetMap = useSelector(state => state.fleet);
    const fleet = useMemo(() => [...fleetMap.values()], [fleetMap]);

    return fleet;
}

export default useFleet;
